import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mobile-callback',
  templateUrl: './mobile-callback.component.html',
  styleUrls: ['./mobile-callback.component.scss']
})
export class MobileCallbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.location.href = environment.oneLogin.mobile_social_authorize;
  }

}
